export const ErrorOldCodesMessages = {
    // AUTH
    E100000: "Error getting user information. Please contact an administrator",
    E100001: "User already registered. Please log in",
    E100002: "User not registered. Please sign up",
    E100003: "You’ve reached the maximum login attempts. Contact us",
} as const;